import {TTypeConstructor} from '@packages/systems/wfdl-ast';
import {withSystem} from '@packages/systems/wfdl';
import {pluginName, qualify, typeName} from '@packages/systems/wfdl-Qualified';

export {dataSourceDefinition, searchFieldAlias} from './searchDataSource';
export * from './types';

function createExcludeSearchType(defaultValue: boolean) {
  return withSystem(
    {isBindable: false, defaultValue, private: true},
    TTypeConstructor(
      qualify(pluginName('Search'), typeName('SearchIndexBoolean'))
    )
  );
}

export const excludeSearchType = createExcludeSearchType(false);

export const excludeSearchByDefaultType = createExcludeSearchType(true);
